import { lazy } from 'react';

export { default as UserLogin } from './user_login/UserLogin';
export { default as ChangePassword } from './change_password/ChangePassword';

export const Profile = lazy(() => import('./profile/Profile'));
export const StaffList = lazy(() => import('./staff/StaffList'));
export const AssignDepartmentList = lazy(() => import('./assignDepartment/AssignDepartmentList'));